import { State, StateContext, StateToken } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { EmitterAction, Receiver } from '@ngxs-labs/emitter'

export const PLUGPLAY = new StateToken<string>('plugplay')

interface PlugplayModel {
  isActive: number
  highestLastStepCompleted: number
  highestStepVisited: number
  isWizardVisible: boolean
}

@State<Partial<PlugplayModel>>({
  name: PLUGPLAY,
  defaults: null,
})
@Injectable()
export class PlugplayState {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  @Receiver()
  static setActive(ctx: StateContext<PlugplayModel>, { payload }: EmitterAction<number>) {
    ctx.patchState({ isActive: payload })
  }

  @Receiver()
  static setHighestLastStepCompleted(ctx: StateContext<PlugplayModel>, { payload }: EmitterAction<number>) {
    ctx.patchState({
      highestLastStepCompleted:
        ctx.getState().highestLastStepCompleted > payload ? ctx.getState().highestLastStepCompleted : payload,
    })
  }
  @Receiver()
  static setHighestStepVisited(ctx: StateContext<PlugplayModel>, { payload }: EmitterAction<number>) {
    ctx.patchState({
      highestStepVisited: ctx.getState().highestStepVisited > payload ? ctx.getState().highestStepVisited : payload,
    })
  }

  @Receiver()
  static setWizardVisibility(ctx: StateContext<PlugplayModel>, { payload }: EmitterAction<boolean>) {
    ctx.patchState({ isWizardVisible: payload })
  }
}
